import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { DRAWER_MESSAGES } from '../../LoanEditorCustomFormDrawer.constants';
import EntitySelector from '../EntitySelector';

import { ClosingCompanySelectorTestIds } from './ClosingCompanySelector.testIds';

const ClosingCompanySelector = ({
  companies,
  disabled = false,
  selectedCompanyId = null,
  onSelect,
}) => (
  <EntitySelector
    dataTestId={ClosingCompanySelectorTestIds.COMPANY_SELECT}
    emptyText={DRAWER_MESSAGES.NO_CLOSING_COMPANIES_AVAILABLE}
    helperText={DRAWER_MESSAGES.CLOSING_COMPANY_SELECTOR_HELPER}
    isDisabled={disabled}
    label={DRAWER_MESSAGES.CLOSING_COMPANY_SELECTOR_LABEL}
    name="loanEditorCustomFormClosingCompanySelector"
    options={companies}
    placeholder={DRAWER_MESSAGES.CLOSING_COMPANY_SELECTOR_PLACEHOLDER}
    selectedId={selectedCompanyId}
    onSelect={onSelect}
  />
);

ClosingCompanySelector.propTypes = {
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      fullName: PropTypes.string,
    }),
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  selectedCompanyId: PropTypes.string,
};

export default memo(ClosingCompanySelector);
